import axios from "axios";
import { Component } from "react";
import { connect } from "react-redux";
import urls from "../urls";
import { setInitialOrderItems } from "../redux-state/features/orderState";
import ManagerTableRow from "../manager/tableRow";
import _ from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBinoculars,
  faCalendarCheck,
  faDoorOpen,
} from "@fortawesome/free-solid-svg-icons";
import {
  faCircleCheck,
  faPenToSquare,
} from "@fortawesome/free-regular-svg-icons";
import {
  setIsMaintenanceApplicationsLoaing,
  setsMaintenanceApplications,
  updateApplictions,
} from "../redux-state/features/maintenance/maintenanceSlice";
import {
  setCredentials,
  clearCredentials,
} from "../redux-state/features/user/userSlice";
import { data, Navigate } from "react-router";
import { showError, showSuccess } from "../utils";
import ChangePassWordModal from "../shared-components/changePassWordModal";
import UserApplicationsDetails from "../user/userApplicationsDetails";
import { setShowOrderModal } from "../redux-state/features/orderState";
import OrderForm from "../shared-components/orderForm";
import ViewOrderItemsModal from "../user/viewOrderModal";
class MaintenanceHome extends Component {
  /**
   *
   */
  constructor() {
    super();
    this.state = {
      LoadingButtons: [],
      show: "applications", // "applications" || "orders tracking"
    };
    this.headerText = [
      "#",
      "المستخدم ",
      "البريد الإلكتروني",
      "الخدمة المطلوبة",

      "",
    ];
  }
  componentDidMount() {
    this.props.setIsMaintenanceApplicationsLoaing(true);
    const { faculty_id } = this.props;
    axios
      .get(urls.getApprovedServices, {
        params: {
          faculty_id,
        },
      })
      .then((res) => {
        const data = res.data.results;
        console.log(res.data);
        this.props.setsMaintenanceApplications(data);
        this.props.setIsMaintenanceApplicationsLoaing(false);
      })
      .finally(() => {
        this.props.setIsMaintenanceApplicationsLoaing(false);
      });
  }
  logOut = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    this.props.clearCredentials();
  };
  addButtonToLoading = (buttonData) => {
    // Use the setState method to update the state
    this.setState((prevState) => ({
      LoadingButtons: [...prevState.LoadingButtons, buttonData],
    }));
  };
  removeButton = (buttonId) => {
    this.setState((prevState) => ({
      LoadingButtons: prevState.LoadingButtons.filter((id) => id !== buttonId),
    }));
  };
  confirmServiceAccomplish = (id) => {
    this.addButtonToLoading(id);
    axios
      .put(urls.confirmOrder, {
        data: {
          orderId: id,
          orderStatus: "confirmed",
          applicationType: "service",
        },
      })
      .then((res) => {
        this.props.updateApplictions({
          service_id: id,
          updatedProperties: {
            service_status: "served",
          },
        });
        showSuccess("تم تأكيد الانتهاء من إنجاز المهمة");
        this.removeButton(id);
      })
      .catch((err) => {
        console.error(err);
        showError("لم يتم تأكيد العملية بنجاح ");
      })
      .finally(() => {
        this.removeButton(id);
      });
  };
  toggleShow = () => {
    this.setState((prevState) => ({
      show:
        prevState.show === "applications" ? "orders tracking" : "applications",
    }));
  };
  render() {
    if (!this.props.isAuthenticated) {
      return <Navigate to="/" replace />;
    }
    const { table_data } = this.props;
    const { show } = this.state;
    return (
      <div>
        <ViewOrderItemsModal />
        <OrderForm />
        <ChangePassWordModal />
        <nav className="navbar navbar-expand-lg  border-bottom mb-3">
          <div className="container-fluid">
            <div className=" navbar-collapse">
              <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                <li>
                  <a
                    className="dropdown-item"
                    href="#"
                    style={{ fontSize: "12px" }}
                    onClick={() =>
                      this.props.setShowOrderModal(setShowOrderModal())
                    }
                  >
                    {" "}
                    <FontAwesomeIcon
                      className="mx-2"
                      icon={faPenToSquare}
                      size="lg"
                    />
                    <span style={{ fontSize: "10px" }}> طلب مواد</span>
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item"
                    href="#"
                    style={{ fontSize: "12px" }}
                    onClick={() => this.toggleShow()}
                  >
                    {" "}
                    <FontAwesomeIcon
                      className="mx-2"
                      icon={
                        show === "applications" ? faBinoculars : faCalendarCheck
                      }
                      size="lg"
                    />
                    <span style={{ fontSize: "10px" }}>
                      {show === "applications"
                        ? "تتبع الطلبات"
                        : "جدول الاعمال"}
                    </span>
                  </a>
                </li>
                <li className="nav-item mx-3"> </li>

                <li className="nav-item"></li>
              </ul>
              <div className="d-flex align-items-center">
                <div
                  className="text-center"
                  style={{ cursor: "pointer" }}
                  onClick={this.logOut}
                >
                  <FontAwesomeIcon icon={faDoorOpen} size="xl" />
                  <p className="m-0" style={{ fontSize: "9px" }}>
                    خروج
                  </p>
                </div>
              </div>
            </div>
          </div>
        </nav>
        {show === "applications" ? (
          <div>
            <h6 className="mt-3 mb-3"> الخدمات المطلوبة</h6>
            <table className="table align-middle">
              <thead className="table-light text-center">
                <tr style={{ fontSize: "12px" }}>
                  {this.headerText.map((txt, idx) => (
                    <th key={"app-header" + idx}>{txt}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {this.props.isLoading ? (
                  <tr>
                    <td colSpan={6} className=" text-center p-3">
                      <div
                        className="spinner-border text-primary"
                        style={{ width: "3rem", height: "3rem" }}
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </td>
                  </tr>
                ) : (
                  table_data.map((obj, idx) => (
                    <tr className="text-center">
                      <td>{idx + 1}</td>
                      <td>{obj.full_name}</td>
                      <td>{obj.email}</td>
                      <td>{obj.service_description}</td>
                      <td>
                        {obj.service_status === "approved" && (
                          <button
                            className="btn  border border-1 text-success"
                            title="تأكيد إنجاز العمل"
                            onClick={() =>
                              this.confirmServiceAccomplish(obj.service_id)
                            }
                          >
                            {this.state.LoadingButtons.includes(
                              obj.service_id
                            ) ? (
                              <div
                                className="spinner-border text-primary"
                                style={{ width: "1rem", height: "1rem" }}
                                role="status"
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                            ) : (
                              <>
                                <FontAwesomeIcon
                                  icon={faCircleCheck}
                                  size="2x"
                                />
                                <p
                                  className="mb-0 mt-1"
                                  style={{ fontSize: "9px", width: "5rem" }}
                                >
                                  تأكيد الانجاز
                                </p>
                              </>
                            )}
                          </button>
                        )}
                        {obj.service_status === "confirmed" && (
                          <p className="m-0 text-success">
                            {" "}
                            تم الانجاز في إنتظار تأكيد المستفيد{" "}
                          </p>
                        )}
                        {obj.service_status === "served" && (
                          <p className="m-0 text-warning">
                            {" "}
                            تم تأكيد المستفيد{" "}
                          </p>
                        )}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        ) : (
          <div>
            <UserApplicationsDetails />
          </div>
        )}
      </div>
    );
  }
}

const mapDispatchToProps = {
  setIsMaintenanceApplicationsLoaing,
  setsMaintenanceApplications,
  clearCredentials,
  updateApplictions,
  setShowOrderModal,
};
const mapStateToProps = (state) => ({
  isLoading: state.maintenanceState.isLoading,
  table_data: state.maintenanceState.applications,
  isAuthenticated: state.userState.isAuthenticated,
  faculty_id: state.userState.faculty_id,
});
export default connect(mapStateToProps, mapDispatchToProps)(MaintenanceHome);
